import {
    SET_MODULES_CLE_LOADING,
    SET_MODULES_CLE_ERROR,
    FETCH_MODULES_CLE_SUCCESS,
    FETCH_MODULES_CLE_FAIL,
    CREATE_MODULE_CLE_FAIL,
    UPDATE_MODULE_CLE_FAIL,
    DELETE_MODULE_CLE_SUCCESS,
    DELETE_MODULE_CLE_FAIL,
} from "../actions/modulesCleActions";

const initialState = {
    loading: false,
    error: null,
    modulesCle: [],
};

export default function modulesCleReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MODULES_CLE_LOADING:
            return { ...state, loading: action.payload };
        case SET_MODULES_CLE_ERROR:
            return { ...state, error: action.payload };

        case FETCH_MODULES_CLE_SUCCESS:
            return { ...state, modulesCle: action.payload || [], error: null };

        case FETCH_MODULES_CLE_FAIL:
        case CREATE_MODULE_CLE_FAIL:
        case UPDATE_MODULE_CLE_FAIL:
        case DELETE_MODULE_CLE_FAIL:
            return { ...state, error: action.payload };

        case DELETE_MODULE_CLE_SUCCESS:
            return { ...state, modulesCle: state.modulesCle.filter((x) => x.id !== action.payload), error: null };

        default:
            return state;
    }
}
